import { render, staticRenderFns } from "./HkNotice.vue?vue&type=template&id=4b663abd&scoped=true&"
import script from "./HkNotice.vue?vue&type=script&lang=js&"
export * from "./HkNotice.vue?vue&type=script&lang=js&"
import style0 from "./HkNotice.vue?vue&type=style&index=0&id=4b663abd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b663abd",
  null
  
)

export default component.exports